module.exports = __webpack_public_path__ + "static/img/bcg.8d987087.webp";